import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import SvgIcons from '../../services/SvgIcons';
import './NavbarAuth.scss';
import { baseURL } from '../../services/config';
import BackgroundImageWithSkeleton from '../../components/BackgroundImageWithSkeleton/BackgroundImageWithSkeleton';

const NavbarAuth = ({ user, onLogout, closeMenu }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();

    const handleLogin = () => {
        navigate('/connexion');
        closeMenu();
    };
    
    const handleLogout = () => {
        onLogout();
        setIsMenuOpen(false);
        closeMenu();
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };


    return (
        <div className="navbar-auth">
            {!user ? (
                <button
                    className="navbar-auth__login-btn"
                    onClick={handleLogin}
                    aria-label="Se connecter"
                    onMouseOver={() => setIsHovered(true)}
                    onMouseOut={() => setIsHovered(false)}
                >
                    <SvgIcons
                        name="login"
                        width="24"
                        height="24"
                        color={isHovered ? "#FFFFFF" : "#36152F"}
                    />
                    <span>Se connecter</span>
                </button>
            ) : (
                <div className="navbar-auth__user"
                    onMouseEnter={toggleMenu}
                    onMouseLeave={toggleMenu}
                >
                    <button
                        className="navbar-auth__user-btn"
                        onClick={toggleMenu}
                        aria-expanded={isMenuOpen}
                        aria-haspopup="true"
                        style={{
                            borderRadius: isMenuOpen ? '0.5rem 0.5rem 0 0' :'0.5rem',
                        }}
                    >
                        {
                            user?.picture ?
                                <BackgroundImageWithSkeleton
                                    picture={user.picture}
                                    width='2rem'
                                    height='2rem'
                                    className="navbar-auth__user-avatar"
                                    positionMobile='static'
                                    positionDesktop='static'
                                    borderRadius='50px'
                                />
                            :
                                <SvgIcons
                                    name="user"
                                    width="32"
                                    height="32"
                                    color="#6D4F47"
                                />
                        }
                        <span className="navbar-auth__user-name">
                            {user.firstname}
                        </span>
                        <SvgIcons
                            name="chevron_back"
                            width="24"
                            height="24"
                            color="#36152F"
                            transform={`rotate(${isMenuOpen ? 90 : -90}deg)`}
                        />
                    </button>

                    {isMenuOpen && (
                        <div className="navbar-auth__menu">
                            <NavLink
                                to='/mon-compte'
                                className="navbar-auth__menu-item"
                                onClick={closeMenu}
                            >
                                <SvgIcons
                                    name="user"
                                    width="24"
                                    height="24"
                                    color="#36152F"
                                />
                                Mon compte
                            </NavLink>
                            {/* <NavLink
                                to='/mes-formations'
                                className="navbar-auth__menu-item"
                                onClick={closeMenu}
                            >
                                <SvgIcons
                                    name="play_circle"
                                    width="24"
                                    height="24"
                                    color="#36152F"
                                />
                                Mes formations
                            </NavLink> */}
                            {/* {
                                user.roles.includes("ROLE_ADMIN") &&
                                    <NavLink
                                        to='/admin'
                                        className="navbar-auth__menu-item"
                                        onClick={closeMenu}
                                    >
                                        <SvgIcons
                                            name="admin"
                                            width="24"
                                            height="24"
                                            color="#36152F"
                                        />
                                        Administration
                                    </NavLink>
                            } */}
                            <button
                                className="navbar-auth__menu-item"
                                onClick={handleLogout}
                            >
                                <SvgIcons
                                    name="logout"
                                    width="24"
                                    height="24"
                                    color="#36152F"
                                />
                                Déconnexion
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default NavbarAuth;